import { useGetAccountServices, useGetPersonalInfo } from '@/hooks/api';
import { useRunOnce } from '@nosinovacao/nosid-mfe-common';
import { createFileRoute } from '@tanstack/react-router';
import { useEffect } from 'react';
import z from 'zod';

export const Route = createFileRoute('/devices')({
  component: RouteComponent,
  errorComponent: RedirectHomeErrorComponent,
  validateSearch: z
    .object({
      device_name: z.string().nullish(),
      device_type: z.string().nullish(),
      redirect_uri: z.string().nullish(),
    })
    .nullish(),
});

function RedirectHomeErrorComponent() {
  const navigate = Route.useNavigate();
  useRunOnce(() => {
    navigate({ to: '/home' });
  });
  return <></>;
}

function RouteComponent() {
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  const { data: personalInfo, isLoading: isPersonalInfoLoading } = useGetPersonalInfo();
  const { data: accountServices, isLoading: isAccountServicesLoading } = useGetAccountServices();
  const isLoading = isPersonalInfoLoading || isAccountServicesLoading;
  useEffect(() => {
    if (isLoading) return;

    const defaultAccountId = personalInfo?.DefaultAccountId;
    const defaultAccountIdExists = accountServices?.Holder?.ServiceAccounts?.find(
      (s) => s.Id === defaultAccountId,
    );
    const sa = defaultAccountIdExists
      ? defaultAccountId
      : accountServices?.Holder?.ServiceAccounts?.find((s) => s.HasTvService)?.Id;

    if (!sa) {
      throw new Error('No service account found for the user');
    }
    navigate({
      to: `/tv/$id/device-management`,
      params: { id: sa },
      search: {
        redirectOnDelete: true,
        device_name: search?.device_name,
        device_type: search?.device_type,
        redirect_uri: search?.redirect_uri,
      },
    });
  });
  return <></>;
}
